export const FILTER_MINE = 'mine'
export const FILTER_ALL = 'all'
export const FILTER_CERTIFIED = 'certified'
export const FILTER_TRASH = 'trash'

export default [FILTER_MINE, FILTER_ALL, FILTER_CERTIFIED, FILTER_TRASH]
